/** Teksty wyszukiwarki globalnej (Ctrl K). */
export const searchPl = {
  groups: { CUSTOMER: 'Klienci', CONTACT: 'Osoby kontaktowe', LEAD: 'Leady', TASK: 'Zadania', REQUEST: 'Akceptacje', VEHICLE: 'Pojazdy' },
  recent: 'Ostatnio otwierane',
  quick: 'Szybkie przejścia',
  pages: 'Widoki',
  showAll: 'Pokaż wszystkie ({count})',
  clear: 'Wyczyść pole',
  clearRecent: 'Wyczyść historię',
  error: 'Nie udało się wyszukać. Spróbuj ponownie.',
  noResults: 'Brak wyników dla „{query}”',
  noResultsHint: 'Sprawdź pisownię lub wpisz fragment nazwy, miasta albo osoby.',
  hintNavigate: 'wybierz',
  hintOpen: 'otwórz',
  hintScope: 'Wyniki ograniczone do Twoich danych',
};

export const searchEn: typeof searchPl = {
  groups: { CUSTOMER: 'Customers', CONTACT: 'Contact people', LEAD: 'Leads', TASK: 'Tasks', REQUEST: 'Approvals', VEHICLE: 'Vehicles' },
  recent: 'Recently opened',
  quick: 'Quick links',
  pages: 'Pages',
  showAll: 'Show all ({count})',
  clear: 'Clear field',
  clearRecent: 'Clear history',
  error: 'Search failed. Please try again.',
  noResults: 'No results for “{query}”',
  noResultsHint: 'Check the spelling or type part of a name, city or person.',
  hintNavigate: 'select',
  hintOpen: 'open',
  hintScope: 'Results are limited to your data',
};
